import React, { Component } from 'react';
import classNames from 'classnames';
import * as uiHelper from '../../util/ui';
import * as helper from '../../util/helper';
import * as html from '../../util/html';
import DragGrid from './DragGrid/DragGrid';
import {
    ArrowItem
    ,UserSelectPage
    ,PopUp
    ,FieldBox
    ,Avatar
} from '@beisen/chaos-ui';
import * as UrlTools from '../../util/url';
import transLoader from '@beisen/i18n-translation-loader';
require('./Staff.scss');
//搜索允许输入的最大字符数，超过将会被截取，并给予提示
const maxUserLength = 200;
const defaultTranslation = {
    required: '必填',
    emptyItem: '空（未填写）',
    staffFaildTip: '数据获取失败',
    dragCellTipMsg: '拖动头像可以调整顺序哦～',
    selectHolder: '点击选择',
    search: '搜索',
    confirm: '确定',
    clear: '清空',
    cancel: '取消',
    loading: '加载中...',
    empty: '空',
    userSearchDataLangError: `最多输入${maxUserLength}个字符，超过${maxUserLength}的字符已被截断`
};

const STYLE_TITLE_UP_AND_DOWN = 'upAndDown';

class Staff extends Component {
	constructor(props,context) {
		super(props,context);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleTouchTap = this.handleTouchTap.bind(this);
        this.handleClearValue = this.handleClearValue.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.fetchDefaultUsers = this.fetchDefaultUsers.bind(this);
        this.fetchSearchUsers = this.fetchSearchUsers.bind(this);
        this.setChangeDatas = this.setChangeDatas.bind(this);
        this.searchDataFormat = this.searchDataFormat.bind(this);
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            required: 'common.required',
            emptyItem: 'common.emptyItem',
            staffFaildTip: 'staff.staffFaildTip',
            dragCellTipMsg: 'staff.dragCellTipMsg',
            selectHolder: 'fieldPlaceHolder.selectHolder',
            search: 'common.search',
            confirm: 'common.confirm',
            clear: 'common.clear',
            cancel: 'common.cancel',
            loading: 'common.loading',
            empty: 'common.empty',
            userSearchDataLangError: 'staff.userSearchDataLangError'
        }), props.translation);
        this.state = {
			showPopUp: false,
            text: this.props.text || '',
            selectedDatas: this.transformStrToArray(props),
            visible: false
            ,isCancle: false
            ,allUsers: this.props.allUsers || []
            ,defaultUsers: this.props.defaultUsers || []
      	};
    }

    componentWillMount() {
        if(this.props.pop_type == 'searchItem') {
            this.setState({ showPopUp: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.pop_type == 'searchItem' && nextProps.visible) {
            this.setState({ showPopUp: true });
        }
        this.setState({ selectedDatas: this.transformStrToArray(nextProps) ,text: nextProps.text || '', allUsers: nextProps.allUsers, defaultUsers: nextProps.defaultUsers || this.state.defaultUsers });
    }

    getFormattedObj(data) {
        let text,value,avatars = {};
        if(data.length >= 1) {
             text = data[0].Name, value = data[0].Id;
             avatars[data[0].Id] = data[0].UserAvatar;
            for(let i = 1; i < data.length; i++) {
                text +=  ',' + data[i].Name;
                value +=  ',' + data[i].Id;
                avatars[data[i].Id] = data[i].UserAvatar;
            }
            return {
                'text': text,
                'value': value,
                 avatars
            };
        }
        return {
            'text': '',
            'value': ''
        };
    }

    transformStrToArray(props) {
        const { translation } = this;
        let selectedUsers = [];
        let propValue = props.value + '';
        if(props.text && propValue || propValue == '#AllowSearchNull#') {
            const selectedValues = propValue.split(',');
            const displayTexts = props.text.split(',');
            for(let i = 0; i < selectedValues.length; i++) {
                if(selectedValues[i] != '') {
                    selectedUsers.push({
                        Id: selectedValues[i] == '#AllowSearchNull#' ? selectedValues[i] : Number(selectedValues[i])
                        , Name: selectedValues[i] == '#AllowSearchNull#' ? translation.emptyItem : (displayTexts[i].match(/\(.*\)$/) ? displayTexts[i].split('(')[0] : displayTexts[i])
                        , UserAvatar: props.avatars ? props.avatars[selectedValues[i]] : null
                    });
                }
            }
        }
        return selectedUsers;
    }

    getUrl() {
        let { datasourceurl } = this.props.cmp_data;
        const locationObj = window.location;
        const applicationName = this.props.cmp_data.applicationName || BSGlobal.application;
        const apiPath = BSGlobal.apiPath.startsWith('//') ? locationObj.protocol + BSGlobal.apiPath : BSGlobal.apiPath;
        let searchurl = `${apiPath}api/v1/${BSGlobal.loginUserInfo.TenantID}/${BSGlobal.loginUserInfo.Id}/user`;
        let defaultUrl = `/api/v2/Data/Contact?app=${applicationName}&formState=${this.props.cmp_data.cmp_state}`;
        datasourceurl = datasourceurl && JSON.parse(datasourceurl);
        if(datasourceurl && datasourceurl.getUserUrl) {
            defaultUrl = this.urlAppendParams(datasourceurl.getUserUrl.url);
        }

        if(datasourceurl && datasourceurl.getSearchUserUrl) {
            searchurl = this.urlAppendParams(datasourceurl.getSearchUserUrl.url);
        }

        return { defaultUrl,searchurl };
    }
    // 请求常用列表
    fetchDefaultUsers() {
        const { translation } = this;
        let defaultUrl = this.getUrl().defaultUrl;
        const nullValue = (!!Number(this.props.cmp_data.AllowSearchNull || 0)) ? { Id: '#AllowSearchNull#', Name: translation.emptyItem, text: translation.emptyItem, value: '#AllowSearchNull#' } : null;
        const successCallBack = function(response) {
            nullValue ? response.unshift(nullValue) : null;
            this.setState({
                allUsers: response || [],
                defaultUsers: response || []
            });
        }.bind(this);
        defaultUrl = helper.ajaxUrlCompletionInCachePage(defaultUrl);
        const failureCallBack = function(error) {
            let tipInfo = { message: error.message || translation.staffFaildTip, type: 'error' };
            if (error.isOffLine) {
                error['type'] = 'error';
                tipInfo = error;
            }
            this.props.actions.showTip(tipInfo);
        }.bind(this);
        window.CommonFetch && window.CommonFetch(defaultUrl, {}, successCallBack, failureCallBack);
    }

    // 请求搜索值列表
    fetchSearchUsers(inVal) {
        if(this.props.fetchSearchUsers) {
            this.props.fetchSearchUsers(inVal);
            return;
        }
        const { translation } = this;
        let fetchUrl = this.getUrl().searchurl,
            params = {
            v: (new Date()).getTime()
            , filters: inVal
            , app: window.BSGlobal.application
        };
        fetchUrl = fetchUrl.replace('{filters}', encodeURIComponent(inVal));
        if (fetchUrl.indexOf('?') > -1 && fetchUrl.indexOf('app') < 0) {
            fetchUrl += '&app=' + params.app;
            params = {};
        }
        const conParam = UrlTools.getConnectSymbol(fetchUrl);
        fetchUrl = fetchUrl + conParam + UrlTools.serializeUrl(params);
        const successCallBack = function(response) {
            let Users = [], UserData = response.Data;
            if (UserData && UserData.SimpleUserModel) {
                for (let key in UserData.SimpleUserModel) {
                    let item = UserData.SimpleUserModel[key];
                    Users.push(item);
                }
            }
            this.setState({ allUsers: Users });
        }.bind(this);
        const failureCallBack = function(error) {
            let tipInfo = { message: error.message || translation.staffFaildTip, type: 'error' };
            if (error.isOffLine) {
                error['type'] = 'error';
                tipInfo = error;
            }
            this.props.actions.showTip(tipInfo);
        }.bind(this);
        fetchUrl = helper.ajaxUrlCompletionInCachePage(fetchUrl);
        window.CommonFetch && window.CommonFetch(fetchUrl, {}, successCallBack, failureCallBack);
    }

    setChangeDatas(datas) {
        this.setState({ selectedDatas: datas },() => {
            this.props.onChange && this.props.onChange(this.getFormattedObj(datas));
        });
    }

	handleTouchTap() {
        this.setState({ showPopUp: true, visible: true },() => {
            this.props.onFocus && this.props.onFocus();
        });
	}

    handleFocus(e) {
        if(e && e.target) {
            e.target.blur();
        }
    }

    handleConfirm(event, data) {
        const autoObj = this.getFormattedObj(data);
        let text = '', avatars = {};
        data.forEach(item => {
            let temp = item.Name;
            text = text === '' ?  temp : text + ',' + temp;
            avatars = item;
        });
        let avatarsInfo = avatars.UserAvatar, Avatars = {};
        if (avatarsInfo) {
            for (let key in avatarsInfo) {
                let newKey = key.substring(0, 1).toLowerCase() + key.substring(1);
                Avatars[newKey] = avatarsInfo[key];
            }
        }
        // 组装数据，便于选中时渲染头像
        const userInfo = {
            Id: avatars.Id,
            Name: avatars.Name,
            avatars: Avatars,
            Email: avatars.Email
        };
        this.data = autoObj;
        if(this.props.pop_type == 'searchItem') {
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.setState({ text: text, isCancle: false, allUsers: [], defaultUsers: [] });
        }else {
            this.setState({ visible: false, text: text, isCancle: true, allUsers: this.props.defaultUsers || [], defaultUsers: this.props.defaultUsers || [], avatarsInfo: userInfo }, () => {
                this.props.onChange && this.props.onChange(autoObj);
            });
        }
        if(this.props.hasDefaultSource) {
            this.props.clearState && this.props.clearState();
        }
    }

    handleClearValue() {
        this.data = { text: '',value: '' };
        if(this.props.pop_type == 'searchItem') {
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.setState({
                text: ''
                ,selectedDatas: []
                ,isCancle: false
                , allUsers: []
                , defaultUsers: []
            });
        }else {
            this.setState({ text: '', visible: false,isCancle: true, selectedDatas: [], allUsers: this.props.defaultUsers || [], defaultUsers: this.props.defaultUsers || [], avatarsInfo: {} }, () => {
                this.props.onChange && this.props.onChange({ text: '',value: '' });
            });
        }
        if(this.props.hasDefaultSource) {
            this.props.clearState && this.props.clearState();
        }
    }

    //取消
    handleCancel() {
        if(this.props.pop_type == 'searchItem') {
            this.props.handleCancel && this.props.handleCancel();
        }
        this.setState({
            visible: false
            ,isCancle: true
            , allUsers: this.props.defaultUsers || []
            , defaultUsers: this.props.defaultUsers || []
        });
        if(this.props.hasDefaultSource) {
            this.props.clearState && this.props.clearState();
        }
    }

    afterClose() {
        if(!this.state.isCancle) {
            this.props.onChange && this.props.onChange(this.data);
            this.props.synBizData && this.props.synBizData();
        }
        this.setState({ showPopUp: false });
    }

    urlAppendParams(url) {
        let paramsReg = /\{\S*?\}/ig;
        let allParams = url.match(paramsReg);
        let bizData = this.props.biz_data;
        allParams && allParams.forEach(item => {
            let items = item.replace(/[\{|\}]/ig ,'').split('.');
            if(items.length == 2 && items[0] == 'data') {
                let data = bizData[items[1]].value;
                url = url.replace(item,data);
            }
        });

        if(url.indexOf('?') > -1) {
            url = url + '&formState=' + this.props.cmp_data.cmp_state;
        }else{
            url = url + '?formState=' + this.props.cmp_data.cmp_state;
        }
        return url;
    }

    setBoxHeader(cnf) {
        helper.generateHeaderConfig(function(headerConfig, setButton) {
			let config = Object.assign({}, headerConfig);
			//设置左侧按钮
			config = setButton('left', cnf.left_item, config);
			//设置右侧按钮
            config = setButton('right', cnf.right_item, config);
			//设置中间数据
			config.titleItem = cnf.title_item;
			return config;
		});
    }
    //用于format 选人组件搜索的数据format，这里用于处理超过500字截断提示的需求
    searchDataFormat(value) {
        if(value.length > maxUserLength){
            let tipInfo = { message: this.translation.userSearchDataLangError, type: 'warning' };
            this.props.actions.showTip(tipInfo);
            return value.substring(0, maxUserLength);
        }
    }
    renderPanel() {
        let { singleSelect , title,isShowDepartmentName } = this.props.cmp_data;

        const style = this.props.pop_type == 'searchList' ? { width: '85%', left: '15%' } : {};
        const animation = this.props.pop_type == 'searchList' ? 'right-slide-fade' : 'bottom-slide-fade';
        const visible = this.props.pop_type == 'searchItem' ? this.props.visible : this.state.visible;
        return (
  			<PopUp visible={visible}
                   animation={animation}
                   maskAnimation="fade"
                   cls='staff_popup'
                   style={style}
                   onClose={this.handleCancel}
                   afterClose={this.afterClose}
            >
                    <UserSelectPage singleSelect={singleSelect}
                        title={uiHelper.strEllipsis(title)}
                        usersList={this.state.allUsers}
                        defaultUsers={this.state.defaultUsers}
                        selectedDatas={this.state.selectedDatas}
                        fetchDefaultUsers={this.fetchDefaultUsers}
                        fetchSearchUsers={this.fetchSearchUsers}
                        hideSearch={this.props.hideSearch}
                        hasDefaultSource={this.props.hasDefaultSource}
                        handleCancel={this.handleCancel}
                        handleConfirm={this.handleConfirm}
                        onClearValue={this.handleClearValue}
                        pop_type={this.props.pop_type}
                        ifHideNav={helper.ifHidePopupNav}
                        setBoxHeader={this.setBoxHeader}
                        decode={html.decode}
                        clearHeaderConfig={helper.clearHeaderConfig}
                        translation={this.translation}
                        searchDataFormat={this.searchDataFormat}
                        isShowDepartment={isShowDepartmentName}
                />
  			</PopUp>
  		);
    }

    renderNormalStaff() {
        const { translation } = this;
        const { styleTitle } = this.props;
        const errMsg = this.props.errorMessage && this.props.errorMessage.message;
        let text = this.state.text.split(',').map(data => {
            let text;
            data.indexOf(translation.emptyItem) > -1 ? text = data : (data.match(/\(.*\)$/) ? text = data.split('(')[0] : text = data);
            return text;
        });
        text = text.join(',');

        // 如有useAddBtn此属性 则使用如下展示方式
        if(this.props.useAddBtn) {
            return (<FieldBox cls="drag-staff-box" hasError={errMsg} required={this.props.required} label={this.props.label} direc="vertical">
                        <DragGrid handleTouchAdd={this.handleTouchTap}
                                            datas={this.state.selectedDatas}
                                            ref="dragGrid"
                                            setChangeDatas={this.setChangeDatas}
                                            translation={translation} />
                                {this.state.showPopUp ? this.renderPanel() : null}
                    </FieldBox>);

        }
        const showPlaceholder = this.props.isReadOnly ? '' : translation.selectHolder;
        let avatarCom = '';
        let hasAvatar = false;
        // 新建或编辑时只选择一个人员时，显示头像
        if (text && text.indexOf(',') == -1 && this.props.pop_type !== 'searchList' && this.props.pop_type !== 'searchItem') {
            if (this.state.avatarsInfo && this.state.avatarsInfo.Id !== '#AllowSearchNull#') {
                hasAvatar = true;
                avatarCom = <span className={classNames('staffArea', { 'avatar-readonly': this.props.isReadOnly })}><Avatar {...this.state.avatarsInfo} scale='medium' /></span>;
            }
        }

        let staffContent = (
            <div className='staffWrap'>
                <div className={classNames('staffContentArea', { 'hasContentArea': text, 'staffContentAreaAlignLeft': styleTitle ===  STYLE_TITLE_UP_AND_DOWN})}>
                    {/* {avatarCom} */}
                    <span className={classNames('staff-content',{ 'placeholder': !text && showPlaceholder, 'staff-readonly': this.props.isReadOnly, 'staff-no-avatar': !hasAvatar })}>{text || showPlaceholder}</span>
                </div>
            </div>
        );
        return (
            <div className="staff-container">
                <ArrowItem
                        type="text"
                        label={this.props.label}
                        value={text}
                        isReadOnly={this.props.isReadOnly}
                        onFocus={this.handleFocus}
                        onClickForm={this.handleTouchTap}
                        cls="slide-form-cont"
                        required={this.props.required}
                        errorMsg={errMsg}
                        desc={this.props.desc}
                        translation={this.translation}
                    styleTitle={this.props.styleTitle}>
                    {staffContent}
                </ArrowItem>
                {this.state.showPopUp ? this.renderPanel() : null}
            </div>
        );
    }

    renderSearchItemStaff() {
        return this.state.showPopUp ? this.renderPanel() : null;
    }

    render() {
        return this.props.pop_type == 'searchItem' ? this.renderSearchItemStaff() :
               this.renderNormalStaff();
    }
}

Staff.PropTypes = {
    'cmp_id': '',
    'cmp_name': '',
    'cmp_type': 'BC_UserSelect',
    'cmp_data': {
        'title': 'title',
        'singleSelect': true,
        'field_name': '',
        'cmp_state': 'create',
        'editdisplaystate': 'readonly',
        'createdisplaystate': 'readonly',
        'showdisplaystate': 'readonly',
        'tips': 'tip',
        'desc': 'description',
        'fetchUrl': 'fetchUrl',
        'datasource': [],
        'renderType': ''
    }
};

export default Staff;



// WEBPACK FOOTER //
// ./src/components/Field_Components/Staff/Staff.js